export enum DATA_QA {
	AI_TOOLS_PANEL = 'ai-tools-panel',
	AI_TOOLS_PANEL_CLOSE_BTN = 'ai-tools-panel-close-button',
	AI_TOOLS_PANEL_SAVE_AND_INSERT_BTN = 'ai-tools-panel-save-and-insert-button',
	AI_TOOLS_PANEL_MAIN_TITLE = 'ai-tools-panel-main-title',
	AI_TOOLS_PANEL_SUMMARY = 'ai-tools-panel-summary',
	AI_TOOLS_PANEL_SEO_TITLE = 'ai-tools-panel-seo-title',
	AI_TOOLS_PANEL_OPERATIONS_CONTAINER = 'ai-tools-panel-operations-container',
	AI_TOOLS_PANEL_GENERATE_CONTENT_BTN = 'ai-tools-panel-generate-content-button',
	AI_TOOLS_PANEL_CONFIRMATION_MODAL = 'ai-tools-panel-generate-content-confirmation-modal',
}
